import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import * as generalIconPaths from "./icons.json"
import * as mainMenuIconPaths from "../../../../../public/mibMainMenuIconsFont.json"

type Props = {
    icon?: Maybe<number>
    color?: Maybe<string>
    size?: Maybe<number>
    path?: Maybe<string>
    className: string
    iconSet?: IconSetType
}

export const IconSetEnum = {
    General: "general",
    MainMenuIcons: "main-menu-icons",
}

export type IconSetType = (typeof IconSetEnum)[keyof typeof IconSetEnum]

export const MenuIconSet = {
    Menu: 0xe900,
    Events: 0xe901,
    Products: 0xe902,
    Tickets: 0xe903,
    Services: 0xe904,
    Drinks: 0xe905,
    Menu2: 0xe906,
    Menu3: 0xe907,
    Services2: 0xe908,
    Services3: 0xe909,
    Drinks2: 0xe90a,
}

/** Internal Figure Icons font containing product/category icons and such. This icon-set is also used on POS. */
class FigureIconFont extends React.PureComponent<Props> {
    static defaultProps = {
        icon: null,
        color: null,
        size: null,
        path: null,
        className: "",
        iconSet: IconSetEnum.General,
    }
    getIconPaths = () => {
        switch (this.props.iconSet) {
            default:
            case IconSetEnum.General:
                return generalIconPaths

            case IconSetEnum.MainMenuIcons:
                return mainMenuIconPaths
        }
    }
    getPath = (iconCode: Maybe<number>): Maybe<string> => {
        const icon = this.getIconPaths().icons.find(i => i.properties.code === iconCode)

        if (icon) {
            return icon.icon.paths.join(" ")
        } else {
            return null
        }
    }

    render() {
        const path = this.props.path || this.getPath(this.props.icon)

        if (!path) {
            return null
        }

        const color = this.props.color ? `#${this.props.color}` : null
        const size = this.props.size || 22
        return (
            <React.Fragment>
                <style jsx={true} global={true}>
                    {`
                        .icon-wrapper {
                            vertical-align: middle;
                            display: inline-block;
                            line-height: 0;
                        }
                    `}
                </style>
                <div className={"icon-wrapper " + this.props.className}>
                    {/* @ts-expect-error */}
                    <svg fill={color} width={size} height={size} viewBox="0 0 1024 1024">
                        <path d={path} />
                    </svg>
                </div>
            </React.Fragment>
        )
    }
}

export default FigureIconFont
